<template>
  <div>
    <ProductHeader header="แก้ไขข้อมูลสินค้า" :img_header="header_image" :link_back="$store.state.link_url"/>
    <Product_edit/>
  </div>
</template>

<script>
import ProductHeader from "@/components/admin/manage_products/header_products/ProductHeader.vue";
import Product_edit from "@/components/admin/manage_products/Product_edit.vue";
import HeaderImage from "@/assets/checklist.png"
export default {
  name: "ProductEdit",
  components: {
    Product_edit,
    ProductHeader
  },
  data() {
    return {
      header_image:HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
